/* THE SIGN — header.js
 * Sticky shadow, mega panele, drawer mobilny, nakładka wyszukiwania.
 * Vanilla JS, bez zależności. Sterowanie atrybutami data-*.
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  /* ----- Tryb nagłówka przy przewijaniu -----
     `is-scrolled` gęstnieje tło papierowego szkła.
     `is-past-hero` przełącza pasek z przezroczystego (nad zdjęciem) na szkło.
     Sam fakt, że strona zaczyna się od hero, rozstrzyga CSS przez :has() — tu
     liczymy tylko moment, w którym zdjęcie wyjeżdża za górną krawędź. */
  var hero = document.querySelector('.main-content > :first-child:is(.hero, .hero-wrapper)');

  var onScroll = function () {
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 4);
    if (hero) {
      /* Próg: dolna krawędź zdjęcia dobija do dolnej krawędzi paska. */
      header.classList.toggle('is-past-hero', y > hero.offsetHeight - header.offsetHeight);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  var lockScroll = function (lock) {
    document.documentElement.classList.toggle('no-scroll', lock);
  };

  /* ----- Mega panele ----- */
  var megaTriggers = Array.prototype.slice.call(header.querySelectorAll('[data-mega-trigger]'));

  var closeAllMega = function (except) {
    megaTriggers.forEach(function (trigger) {
      if (trigger === except) return;
      trigger.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  };

  megaTriggers.forEach(function (trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    var setOpen = function (open) {
      if (open) closeAllMega(trigger);
      trigger.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    };

    trigger.addEventListener('click', function () {
      setOpen(trigger.getAttribute('aria-expanded') !== 'true');
    });

    /* Hover na desktopie (mysz) — panel otwiera się płynnie, zamyka z lekkim opóźnieniem */
    var hoverMedia = window.matchMedia('(hover: hover) and (min-width: 990px)');
    var navItem = trigger.closest('.site-header__nav-item');
    var closeTimer = null;

    var scheduleClose = function () {
      closeTimer = window.setTimeout(function () {
        setOpen(false);
      }, 180);
    };
    var cancelClose = function () {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    if (navItem) {
      navItem.addEventListener('mouseenter', function () {
        if (!hoverMedia.matches) return;
        cancelClose();
        setOpen(true);
      });
      navItem.addEventListener('mouseleave', function () {
        if (!hoverMedia.matches) return;
        scheduleClose();
      });
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', function () {
        if (hoverMedia.matches) scheduleClose();
      });
    }

    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        trigger.focus();
      }
    });

    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        trigger.focus();
      }
    });
  });

  document.addEventListener('click', function (event) {
    if (!header.contains(event.target)) closeAllMega();
  });

  /* ----- Nakładka wyszukiwania ----- */
  var searchToggle = header.querySelector('[data-search-toggle]');
  var searchOverlay = header.querySelector('[data-search-overlay]');
  var searchClose = header.querySelector('[data-search-close]');

  var setSearchOpen = function (open) {
    if (!searchToggle || !searchOverlay) return;
    searchToggle.setAttribute('aria-expanded', String(open));
    searchOverlay.hidden = !open;
    if (open) {
      var input = searchOverlay.querySelector('input[type="search"]');
      if (input) input.focus();
    } else {
      searchToggle.focus();
    }
  };

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      setSearchOpen(searchToggle.getAttribute('aria-expanded') !== 'true');
    });
    if (searchClose) {
      searchClose.addEventListener('click', function () {
        setSearchOpen(false);
      });
    }
    searchOverlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setSearchOpen(false);
    });
  }

  /* ----- Drawer mobilny ----- */
  var drawer = header.querySelector('[data-drawer]');
  var drawerOpen = header.querySelector('[data-drawer-open]');
  var drawerCloses = header.querySelectorAll('[data-drawer-close]');

  var setDrawerOpen = function (open) {
    if (!drawer || !drawerOpen) return;
    if (open) {
      drawer.hidden = false;
      /* wymuszenie reflow dla animacji wejścia */
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      drawerOpen.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      var firstLink = drawer.querySelector('.drawer__close');
      if (firstLink) firstLink.focus();
    } else {
      drawer.classList.remove('is-open');
      drawerOpen.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      window.setTimeout(function () {
        drawer.hidden = true;
      }, 300);
      drawerOpen.focus();
    }
  };

  if (drawer && drawerOpen) {
    drawerOpen.addEventListener('click', function () {
      setDrawerOpen(true);
    });
    Array.prototype.forEach.call(drawerCloses, function (btn) {
      btn.addEventListener('click', function () {
        setDrawerOpen(false);
      });
    });
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setDrawerOpen(false);
    });
  }
})();
